import script from "./ChatTopBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatTopBar.vue?vue&type=script&setup=true&lang=ts"

import "./ChatTopBar.vue?vue&type=style&index=0&id=c0d43abc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0d43abc"]])

export default __exports__